import Layout from "@/layouts/authorised/index.vue"
import Errors from "@/views/errors/404/index.vue"
import Redirect from "@/views/redirect/index.vue"
import Default from "@/layouts/default/index.vue"
import { RouteConfig } from "vue-router"

export interface CustomRouteConfig extends RouteConfig {
    hidden?: boolean
    alwaysShow?: boolean
    children?: CustomRouteConfig[]
}

export const defaultRoutes: CustomRouteConfig[] = [
    {
        name: "error",
        path: "/error",
        redirect: "/error/404",
        hidden: true,
        meta: {
            title: "错误"
        },
        component: Layout,
        children: [
            {
                name: "404",
                path: "404",
                meta: {
                    title: "404"
                },
                component: Errors
            }
        ]
    },
    {
        name: "historicalVersion",
        path: "/privacyPolicy/",
        redirect: "/privacyPolicy/historicalVersion",
        hidden: true,
        meta: {
            title: "隐私政策历史版本",
            noAuth: true // 标记为无需登录验证
        },
        component: Default,
        children: [
            {
                name: "historicalVersion",
                path: "historicalVersion",
                meta: {
                    title: "隐私政策历史版本",
                    noAuth: true // 子路由也需要标记
                },
                component: () => import("@/views/policy/components/historical-version.vue") // 这里可以替换为您的公开页面组件
            }
        ]
    },
    {
        name: "supply",
        path: "/supply",
        redirect: "/supply/field",
        hidden: true,
        meta: {
            title: "错误"
        },
        component: Default,
        children: [
            {
                name: "field",
                path: "field",
                meta: {
                    title: "工单字段补充"
                },
                component: () => import("@/views/middle/field-supply.vue")
            }
        ]
    },
    {
        name: "notice",
        path: "/notice",
        hidden: true,
        meta: {
            title: "通知",
            noAuth: true // 通知页面无需登录验证
        },
        component: Default,
        children: [
            {
                name: "lock",
                path: "lock",
                meta: {
                    title: "锁版通知",
                    noAuth: true
                },
                component: () => import("@/views/notice/lock.vue")
            },
            {
                name: "release",
                path: "release",
                meta: {
                    title: "发布通知",
                    noAuth: true
                },
                component: () => import("@/views/notice/release.vue")
            }
        ]
    },
    {
        name: "redirect",
        path: "/redirect/:path*",
        hidden: true,
        meta: {
            title: "重定向"
        },
        component: Redirect
    }
]

export const asyncRoutes: CustomRouteConfig[] = [
    {
        name: "index",
        path: "/",
        redirect: "/trends/iteration",
        hidden: true
    },
    {
        name: "trends",
        path: "/trends",
        redirect: "/trends/iteration",
        component: Layout,
        meta: {
            title: "产品动态",
            icon: "iconfont icon-a-banbendiedaicengji"
        },
        children: [
            {
                name: "iteration",
                path: "iteration",
                meta: {
                    title: "产品迭代计划"
                },
                component: () => import("@/views/trends/iteration/index.vue")
            },
            {
                name: "release",
                path: "release",
                meta: {
                    title: "产品发布动态"
                },
                component: () => import("@/views/trends/release/index.vue")
            }
        ]
    },
    {
        name: "manage",
        path: "/manage",
        redirect: "/manage/product",
        component: Layout,
        meta: {
            title: "产品管理",
            icon: "iconfont icon-icon_yingyongguanli"
        },
        children: [
            {
                name: "product",
                path: "product",
                meta: {
                    title: "产品列表"
                },
                component: () => import("@/views/manage/product/index.vue")
            },
            {
                name: "product-detail",
                path: "product-detail",
                hidden: true,
                meta: {
                    title: "产品详情"
                },
                component: () => import("@/views/manage/product/detail.vue")
            },
            {
                name: "product-edit",
                path: "product-edit",
                hidden: true,
                redirect: "product-detail", // 兼容老链接
                meta: {
                    title: "产品编辑"
                }
            },
            {
                name: "version",
                path: "version",
                meta: {
                    title: "版本列表"
                },
                component: () => import("@/views/manage/version/index.vue")
            },
            {
                name: "version-detail",
                path: "version-detail",
                hidden: true,
                meta: {
                    title: "版本详情"
                },
                component: () => import("@/views/manage/version/detail.vue")
            },
            {
                name: "version-edit",
                path: "version-edit",
                hidden: true,
                meta: {
                    title: "版本编辑"
                },
                component: () => import("@/views/manage/version/edit.vue")
            },
            {
                name: "version-lock",
                path: "version-lock",
                hidden: true,
                meta: {
                    title: "锁版"
                },
                component: () => import("@/views/manage/version/lock.vue")
            },
            {
                name: "version-release",
                path: "version-release",
                hidden: true,
                meta: {
                    title: "发布"
                },
                component: () => import("@/views/manage/version/release.vue")
            },
            {
                name: "version-schedule",
                path: "version-schedule",
                hidden: true,
                meta: {
                    title: "调整排期"
                },
                component: () => import("@/views/manage/version/schedule.vue")
            },
            {
                name: "version-suspend",
                path: "version-suspend",
                hidden: true,
                meta: {
                    title: "暂停发布"
                },
                component: () => import("@/views/manage/version/suspend.vue")
            },
            {
                name: "aigc",
                path: "aigc",
                meta: {
                    title: "AIGC功能列表"
                },
                component: () => import("@/views/manage/aigc/index.vue")
            },
            {
                name: "aigc-detail",
                path: "aigc-detail",
                hidden: true,
                meta: {
                    title: "AIGC功能详情"
                },
                component: () => import("@/views/manage/aigc/detail.vue")
            },
            {
                name: "aigc-edit",
                path: "aigc-edit",
                hidden: true,
                meta: {
                    title: "AIGC功能编辑"
                },
                component: () => import("@/views/manage/aigc/edit.vue")
            },
            {
                name: "aigc-add",
                path: "aigc-add",
                hidden: true,
                meta: {
                    title: "AIGC功能新增"
                },
                component: () => import("@/views/manage/aigc/edit.vue")
            }
        ]
    },
    {
        name: "policy",
        path: "/policy",
        redirect: "/policy/manage",
        component: Layout,
        alwaysShow: true,
        meta: {
            title: "隐私政策",
            icon: "iconfont icon-icon-shezhi"
        },
        children: [
            {
                name: "manage",
                path: "manage",
                meta: {
                    title: "隐私政策管理"
                },
                component: () => import("@/views/policy/list/index.vue")
            },
            {
                name: "edit",
                path: "edit",
                hidden: true,
                meta: {
                    title: "编制隐私政策"
                },
                component: () => import("@/views/policy/other/edit.vue")
            },
            {
                name: "detail",
                path: "detail",
                hidden: true,
                meta: {
                    title: "隐私政策详情"
                },
                component: () => import("@/views/policy/other/detail.vue")
            }
        ]
    },
    {
        name: "privacyPolicy",
        path: "/privacyPolicy",
        hidden: true,
        meta: {
            title: "隐私政策预览"
        },
        component: Default,
        children: [
            {
                name: "preview",
                path: "preview",
                meta: {
                    title: "隐私政策预览"
                },
                component: () => import("@/views/policy/other/preview.vue")
            }
        ]
    },
    {
        name: "channel",
        path: "/channel",
        redirect: "/channel/manage",
        component: Layout,
        alwaysShow: true,
        meta: {
            title: "配置中心",
            icon: "iconfont icon-icon-shezhi"
        },
        children: [
            {
                name: "manage",
                path: "manage",
                meta: {
                    title: "渠道管理"
                },
                component: () => import("@/views/channel/index.vue")
            },
            {
                name: "cdn",
                path: "cdn",
                meta: {
                    title: "CDN域名管理"
                },
                component: () => import("@/views/channel/cdn/index.vue")
            },
            {
                name: "contrast-list",
                path: "contrast-list",
                meta: {
                    title: "产品与隐私政策URL对照"
                },
                component: () => import("@/views/channel/contrast/index.vue")
            },
            {
                name: "contrast-edit",
                path: "contrast-edit",
                hidden: true,
                meta: {
                    title: "产品与隐私政策URL对照编辑"
                },
                component: () => import("@/views/channel/contrast/edit.vue")
            },
            {
                name: "contrast-detail",
                path: "contrast-detail",
                hidden: true,
                meta: {
                    title: "产品与隐私政策URL对照详情"
                },
                component: () => import("@/views/channel/contrast/detail.vue")
            },
            {
                name: "config",
                path: "config",
                meta: {
                    title: "隐私政策文本类型配置"
                },
                component: () => import("@/views/channel/config/index.vue")
            },
            {
                name: "corporate",
                path: "corporate",
                meta: {
                    title: "公司主体配置"
                },
                component: () => import("@/views/channel/corporate/index.vue")
            }
        ]
    },
    // 404 放到最后
    { path: "*", redirect: "error/404", hidden: true }
]
